import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { StoreUpdateVenueRequestSchema } from '~/services/api/generated'

// UpdateStoreVenueRequest saves the cuisines, venue tags and seating capacity as one unit; an empty tag set is valid.
const schema = StoreUpdateVenueRequestSchema.strict()

export const StoreUpdateVenue = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>, z.input<typeof schema>> => schema
